export default {
    data() {
        return {
            t: this.$root.t,
            loading: false
        }
    },
    methods: {
        fetchMatchBetStat (matchId = 0) {
            return this.$http.get(api+'api/v1/bet/match/stats/'+matchId, {emulateJSON:true})
        },
        regenerateBetByMarketId (id, resultId = 1) {
            return this.$http.post(api+'api/v1/bet/reset/market/'+id, {oddId: id, resultId: resultId}, {emulateJSON:true})
        },
        regenerateBetByOddId (id, resultId = 1) {
            return this.$http.post(api+'api/v1/bet/reset/odd/'+id, {oddId: id, resultId: resultId}, {emulateJSON:true})
        },
        regenerateBetsByMatchId (id) {
            return this.$http.post(api+'api/v1/bet/reset/match/'+id, {matchId: id}, {emulateJSON:true})
        },
        setCancelledBetsByMatchId (id) {
            return this.$http.post(api+'api/v1/bet/cancel/match/'+id, {matchId: id}, {emulateJSON:true})
        },
        resetMarket (id, resultId) {

            var th = this;
            swal({
                title: th.t.alert.are_you_sure,
                text: th.t.reset_bet_message,
                icon: "warning",
                buttons: [
                    th.t.alert.button.not_sure,
                    th.t.alert.button.yes
                ],
                dangerMode: true,
            }).then(function(isConfirm) {
                if (isConfirm) {

                    th.regenerateBetByMarketId(id,resultId).then(response => {

                        th.loading = false;

                    swal({
                        title: th.t.alert.success,
                        text: th.t.processing.success,
                        icon: 'success'
                    }).then(function() {
                        th.$emit("success", true);
                    });

                }, response => {
                        th.loading = false;
                    })

                } else {


                }
            })
        },
        regenerateBet (id, resultId) {

            var th = this;
            swal({
                title: th.t.alert.are_you_sure,
                text: th.t.reset_bet_message,
                icon: "warning",
                buttons: [
                    th.t.alert.button.not_sure,
                    th.t.alert.button.yes
                ],
                dangerMode: true,
            }).then(function(isConfirm) {
                if (isConfirm) {

                    th.regenerateBetByOddId(id,resultId).then(response => {

                        th.loading = false;

                        swal({
                            title: th.t.alert.success,
                            text: th.t.processing.success,
                            icon: 'success'
                        }).then(function() {
                            th.$emit("success", true);
                        });

                    }, response => {
                        th.loading = false;
                    })

                } else {


                }
            })
        },
        regenerateAllMatchBets (id) {

            var th = this;
            swal({
                title: th.t.alert.are_you_sure,
                text: th.t.reset_bet_message,
                icon: "warning",
                buttons: [
                    th.t.alert.button.not_sure,
                    th.t.alert.button.yes
                ],
                dangerMode: true,
            }).then(function(isConfirm) {
                if (isConfirm) {

                    th.regenerateBetsByMatchId(id).then(response => {

                        th.loading = false;

                        swal({
                            title: th.t.alert.success,
                            text: th.t.processing.success,
                            icon: 'success'
                        }).then(function() {
                            th.$emit("success", true);
                        });

                    }, response => {
                            th.loading = false;
                    })

                }
            })
        },
        cancellAllMatchBets (id) {

            var th = this;
            swal({
                title: th.t.alert.are_you_sure,
                text: th.t.reset_bet_message,
                icon: "warning",
                buttons: [
                    th.t.alert.button.not_sure,
                    th.t.alert.button.yes
                ],
                dangerMode: true,
            }).then(function(isConfirm) {
                if (isConfirm) {

                    th.setCancelledBetsByMatchId(id).then(response => {
                        th.loading = false;

                        swal({
                            title: th.t.alert.success,
                            text: th.t.processing.success,
                            icon: 'success'
                        }).then(function() {
                            th.$emit("success", true);
                        });

                }, response => {
                        th.loading = false;
                    })

                }
            })
        },
        fetchBetStatus () {

            return this.$http.get(api+'api/v1/bet/results');
        }
    }
}


// WEBPACK FOOTER //
// ./src/mixins/betmanager.js